import { AuthService } from './../../shared/models/auth.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DataListModel, ApplicationRouteURL, WeGoConfig, IKeyValueInterface } from './../../shared/config';
import { SignupModel } from "../../signup/models/signup.model";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";
import { InvoiceService } from "../models/invoice.service";
import { DirectDebitFile } from "../models/direct-debit-file.model";


@Component({
  selector: 'wego-directdebit-file-list',
  template: require('../views/directdebit-file-list.component.html'),
  providers: [InvoiceService],
  styles: [`.truncate-event-data{
        max-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }`
  ]
})
export class DirectDebitFileListComponent implements OnInit {
  isDirectDebitEnabled: boolean;
  flatPickrConfigTo: FlatPickrModel;
  flatPickrConfigFrom: FlatPickrModel;
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_FORMAT;
  directDebitFileModel: DirectDebitFile = new DirectDebitFile();
  DataListModel: DataListModel;
  directDebitFile: DirectDebitFile[];
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  urlsignupformconfigUpdatePage: string;
  isParentCheck: boolean;
  deleteSignupFormConfigHashId: string;
  errorMessage: string;
  isMultipleDelete: boolean;
  deleteMessage: string;
  urlSignupFormConfigList: string;
  errorModel: IKeyValueInterface[];

  @ViewChild('confirmSignupModal') public confirmSignupModal: any;
  private popupMsg: string;
  private module: string;


  constructor(private invoiceService: InvoiceService,
    private translateService: TranslateService,
    private authService: AuthService,
    private router: Router) { }


  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = false;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  ngOnInit() {
    this.module = this.translateService.instant('LblDirectDebitFile');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ['id', 'companyName'];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlsignupformconfigUpdatePage = this.authService.GetURL(ApplicationRouteURL.URL_SIGNUPFORM_UPDATE);
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.GetDirectDebitFileList();
  }

  public GetDirectDebitFileList() {
    this.isLoading = true;

    this.invoiceService.GetDirectDebitFileList(this.DataListModel, this.directDebitFileModel)
      .subscribe(
      res => {
        this.directDebitFile = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.isLoading = false;
        this.errorModel = [];
        if (typeof res.error == "string") {
          this.DataListModel.infoMessage = res.error;
        } else if (res.error) {
          this.errorModel = res.error;
          this.DataListModel.infoMessage = this.translateService.instant('LblNoDataFound');
        }
        this.IsDirectDebitEnabled();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public IsDirectDebitEnabled() {
    this.invoiceService.IsDirectDebitEnabled()
      .subscribe(
      (res: any) => {
        if (res) {
          this.isDirectDebitEnabled = res.data;
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetDirectDebitFileList();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetDirectDebitFileList();
  }

  public OnDateSearch() {
    this.GetDirectDebitFileList();
  }

  public OnSearch(event: any) {
    if (event.isReset) {
      this.directDebitFileModel.startDateTime = '';
      this.directDebitFileModel.endDateTime = '';
    }
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetDirectDebitFileList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetDirectDebitFileList();
  };


  public GetStatusText(status: string) {
    if (status == 'PENDING_APPROVAL') {
      return "Pending Approval";
    } else if (status == 'APPROVED') {
      return "Approved";
    }
    else if (status == 'REJECTED') {
      return "Rejected";
    }
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.invoiceService.ExportDirectDebitFileList(this.DataListModel, this.directDebitFileModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "DirectDebitFile" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnReCreate(directDebitFileHashId: string) {
    this.invoiceService.ReCreateDirectDebitFile(directDebitFileHashId).subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "directDebitFile" + new Date().toISOString() + ".xml";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoice/components/directdebit-file-list.component.ts